import AdjustHtml from "./utils-company/AdjustHtml";
import SpMenu from "./utils-company/SpMenu";
import FixMovie from "./utils-company/FixMovie";
import SmoothScroll from "./utils-company/SmoothScroll";
import PageTop from "./utils-company/PageTop";
import AdjustStatement from "./utils-company/AdjustStatement";

class Main {
  constructor() {}
}

window.addEventListener("DOMContentLoaded", () => {
  new Main();
  new AdjustHtml();
  new SpMenu();
  new FixMovie();
  new SmoothScroll();
  new PageTop();
  new AdjustStatement();
});
